const isValidEmailAddress = email => {
  let valid = false
  if (email && email.length) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    valid = re.test(String(email).toLowerCase())
  }
  return valid
}

export default isValidEmailAddress
